export default __webpack_public_path__ + "static/media/Hero.4b047912.jpg";